import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Icon } from 'grab-ui';
import css from './header.less';
import logoSvg from '../../public/images/grab-logo.svg';
import { HEADER_DELIVERY_DETAILS } from '../../constants/language-translations';

const Header = props => {
  const { showTransitView, handleMobileViewClose, mobileDetailsOpen } = props;
  const renderMobileCloseButton = () =>
    mobileDetailsOpen ? (
      <button onClick={handleMobileViewClose}>
        <Icon type="grabicon-close-01" />
      </button>
    ) : null;
  return !showTransitView || mobileDetailsOpen ? (
    <div className={css.header}>
      <img alt="grab.com" src={logoSvg} />
      <h1>{I18n.t(HEADER_DELIVERY_DETAILS)}</h1>
      {renderMobileCloseButton()}
    </div>
  ) : null;
};

Header.defaultProps = {
  mobileDetailsOpen: false,
  showTransitView: false,
  handleMobileViewClose: null,
};

Header.propTypes = {
  mobileDetailsOpen: PropTypes.bool,
  showTransitView: PropTypes.bool.isRequired,
  handleMobileViewClose: PropTypes.func,
};
export default Header;
